import { render, staticRenderFns } from "./SubZone.vue?vue&type=template&id=60b87fee&scoped=true&"
import script from "./SubZone.vue?vue&type=script&lang=ts&"
export * from "./SubZone.vue?vue&type=script&lang=ts&"
import style0 from "./SubZone.vue?vue&type=style&index=0&id=60b87fee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b87fee",
  null
  
)

export default component.exports